import { render, staticRenderFns } from "./TreeselectComponent.vue?vue&type=template&id=356a0611"
import script from "./TreeselectComponent.vue?vue&type=script&lang=js"
export * from "./TreeselectComponent.vue?vue&type=script&lang=js"
import style0 from "./TreeselectComponent.vue?vue&type=style&index=0&id=356a0611&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports